
































































import { Component, Vue } from 'vue-property-decorator';
import Register from './User/Register.vue';
import { UserViewModel, UserService } from '../api/user';
import global from '../utils/global';
import { Message } from 'element-ui';

@Component({
  components: {
    Register,
  },
})
export default class HomeContainer extends Vue {
  private showRegister: boolean = false;
  private service: UserService = new UserService();
  private data: UserViewModel = this.service.NewModel;
  private userType: number = global.getUserType();
  private register_OnSaved() {
    Message.success('注册成功');
    this.showRegister = false;
  }
  private btnLogin_OnClick() {
    (window as any).mgr.signinRedirect();
  }
  private btnLogout_OnClick() {
    (window as any).mgr.signoutRedirect();
  }
  private mounted() {
    if (global.getAccessToken() !== undefined) {
      this.service.GetInfo().then((response: any) => {
        this.data = response;
      });
    }
  }
  private settingMenu_OnClick(e: any) {
    this.$router.push({name: e});
  }
}
